
import DaisoImage from '~/components/common/DaisoImage.vue'
import { toggleChatbotWidget } from '~/utils/chatbotWidget'

export default {
  components: { DaisoImage },
  props: {
    showButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isChatbotEnabled () {
      return process.env.CHATBOT_ENABLED !== 'false'
    }
  },
  methods: {
    // 챗봇 패널 열기/닫기 (현재 페이지 우측 하단 고정)
    openChatBot () {
      toggleChatbotWidget()
    }
  }
}
